var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 2.66665V10.6666C5.33334 11.0203 5.47381 11.3594 5.72386 11.6095C5.97391 11.8595 6.31305 12 6.66667 12H12C12.3536 12 12.6928 11.8595 12.9428 11.6095C13.1929 11.3594 13.3333 11.0203 13.3333 10.6666V4.82798C13.3333 4.65035 13.2978 4.47452 13.2289 4.31081C13.16 4.1471 13.059 3.99881 12.932 3.87465L10.722 1.71331C10.4729 1.46975 10.1384 1.33336 9.79 1.33331H6.66667C6.31305 1.33331 5.97391 1.47379 5.72386 1.72384C5.47381 1.97389 5.33334 2.31302 5.33334 2.66665V2.66665Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 12V13.3333C10.6667 13.6869 10.5262 14.0261 10.2761 14.2761C10.0261 14.5262 9.68696 14.6666 9.33334 14.6666H4C3.64638 14.6666 3.30724 14.5262 3.0572 14.2761C2.80715 14.0261 2.66667 13.6869 2.66667 13.3333V5.99996C2.66667 5.64634 2.80715 5.3072 3.0572 5.05715C3.30724 4.8071 3.64638 4.66663 4 4.66663H5.33334",
    stroke: "#4F4F4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1797fed29730d1a57463f7d1fd9113a7.svg";
export { ForwardRef as ReactComponent };